<template>
	<div class="admin-manager-profile">
		<div class="vx-row">
			<div class="info-card vx-col sm:w-1/2 lg:w-1/3 w-full mb-10">
				<vx-card class="flex items-center h-full">
					<div class="flex justify-between items-center box-top h-full">
						<div class="des w-full">
							<span class="info-card__value">{{ totalIncome.income_total }} €</span>
							<p class="info-card__title">{{ $t('totalIncome') }}</p>
						</div>
						<div class="icon icon_green ml-3">
							<feather-icon color="#3AC47D" icon="CreditCardIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="info-card vx-col sm:w-1/2 lg:w-1/3 w-full mb-10">
				<vx-card class="flex items-center h-full">
					<div class="flex justify-between items-center box-top h-full">
						<div class="des w-full">
							<span class="info-card__value">{{ totalOrders.orders_total }}</span>
							<p class="info-card__title">{{ $t('totalOrders') }}</p>
						</div>
						<div class="icon icon_blue ml-3">
							<feather-icon icon="FileTextIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="info-card vx-col sm:w-1/2 lg:w-1/3 w-full mb-10">
				<vx-card class="flex items-center h-full">
					<div class="flex justify-between items-center box-top h-full">
						<div class="des w-full">
							<span class="info-card__value">{{ ordersPaid.count }}</span>
							<p class="info-card__title">{{ $t('paidOrder') }}</p>
						</div>
						<div class="icon icon_green ml-3">
							<feather-icon icon="FileTextIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="info-card vx-col sm:w-1/2 lg:w-1/2 w-full mb-10">
				<vx-card class="flex items-center h-full">
					<div class="flex justify-between items-center box-top h-full">
						<div class="des w-full">
							<span class="info-card__value">{{ ordersWaiting.count }} %</span>
							<p class="info-card__title">{{ $t('hangingOrders') }}</p>
						</div>
						<div class="icon icon_orange ml-3">
							<feather-icon icon="AlertCircleIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="info-card info-card_dropdown vx-col lg:w-1/2 w-full mb-10">
				<vx-card class="flex items-center h-full">
					<div class="flex justify-between items-center box-top h-full">
						<div class="des">
							<span class="info-card__value">
								<span class="info-card_green">
									{{ ordersSuccess.count_success }}
								</span>
								/
								<span class="info-card_red">
									{{ ordersSuccess.count_fail }}
								</span>
							</span>
							<p class="info-card__title">{{ $t('success') }}</p>
						</div>
						<div class="icon icon_purple ml-3">
							<feather-icon icon="ThumbsUpIcon"></feather-icon>
						</div>
					</div>
					<vx-card class="info-dropdown">
						<div class="info-dropdown__list">
							<div
								v-for="(reason, reasonIndex) in ordersSuccess.order_fail_reason"
								:key="reasonIndex"
								class="info-dropdown__item"
							>
								<div class="info-dropdown__count">{{ reason.count }}</div>
								<div class="info-dropdown__name">{{ reason.name }}</div>
							</div>
						</div>
					</vx-card>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col admin-manager-profile__view mb-5">
				<vx-card>
					<vs-tabs>
						<vs-tab :label="$t('profile')">
							<ManagerInfo
								:model="model"
								:languages="languages"
								:genders="genders"
								:countries="countries"
							/>
						</vs-tab>
						<vs-tab :label="$t('sitesPreferences')" class="mt-5">
							<ManagerSites
								:manager="model"
							/>
						</vs-tab>
					</vs-tabs>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import ManagerInfo from "./ManagerInfo";
import ManagerSites from "@/components/profile/ManagerSites";

export default {
	name: "Author",
	components: {
		ManagerInfo,
		ManagerSites
	},
	data() {
		return {
			popupActive: false,
			val: '',
			model: {},
			description: '',
			countries: [],
			genders: [],
			languages: [],
			subjects: [],

			totalIncome: {},
			totalOrders: {},
			ordersPaid: {},
			ordersWaiting: {},
			ordersSuccess: {},
		}
	},
	async mounted() {
		try {
			this.model = (await this.$http('/admin/manager/view/'+this.$route.params.id)).data.data
			this.languages = (await this.$http.get('/settings/get-languages')).data.data;
			this.subjects =  (await this.$http.get('/settings/get-subjects')).data.data;
			this.countries = (await this.$http.get('/settings/get-countries')).data.data
			this.genders = (await this.$http.get('/settings/get-genders')).data.data

			this.totalIncome = (await this.$http.get('/admin/manager/get-income-total/'+this.$route.params.id)).data.data;
			this.totalOrders = (await this.$http.get('/admin/manager/get-orders-total/'+this.$route.params.id)).data.data;
			this.ordersPaid =  (await this.$http.get('/admin/manager/get-orders-paid-count/'+this.$route.params.id)).data.data;
			this.ordersWaiting =  (await this.$http.get('/admin/manager/get-orders-waiting-count/'+this.$route.params.id)).data.data;
			this.ordersSuccess =  (await this.$http.get('/admin/manager/get-success-rate/'+this.$route.params.id)).data.data;
		} catch (e) {

		}
	},
	methods: {
		acceptChangeManager() {

		}
	}
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.admin-manager-profile {
	&__view {
		width: 75%;

		@media screen and (max-width: 1500px){
			width: 100%;
		}
	}

	.feature {
		span {
			color: $success;
		}

		.vx-card__body {
			display: flex;
			justify-content: space-between;
			align-items: center;
			background-color: red;
			height: 100%;
		}

		strong {
			font-size: rem(18px);

			b {
				color: $danger;
			}
		}
	}

	.info-card {
		&_red {
			color: #DB3B26;
		}

		&_green {
			color: #54AD32;
		}

		&__value {
			font-size: 21px;
			font-weight: 600;
		}

		&_dropdown {
			cursor: pointer;

			.vs-card {
				position: relative;
			}

			&:hover .info-dropdown {
				visibility: visible;
				opacity: 1;
			}

			.info-dropdown {
				visibility: hidden;
				position: absolute;
				top: calc(100% + 20px);
				left: 0;
				z-index: 100;
				max-width: 100%;
				opacity: 0;
				transition:
					visibility 0.3s ease-out,
					opacity 0.3s ease-out;

				&__item {
					display: flex;
					align-items: center;
				}

				&__count {
					margin-right: 10px;
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 7px;
					font-size: 22px;
					font-weight: 600;
					color: #EA5455;
					background-color: #FBE6E6;
					border-radius: 10px;
					min-width: 46px;
				}

				.vx-card__collapsible-content,
				.vx-card__body {
					height: 100%;
				}

				.vx-card__body {
					display: flex;
					align-items: center;
				}
			}
		}

		.vx-card__collapsible-content {
			width: 100%;
		}

		.vx-card__body {
			width: 100%;
		}

		.icon {
			display: flex;
			align-items: center;
			padding: 13px;
			border-radius: 10px;

			font-size: 20px;

			svg {
				width: 27px;
				height: 27px;
			}

			&_green {
				color: rgb(58, 196, 125);
				background-color: #E4F6ED;
			}

			&_blue {
				color: #00CFE8;
				background-color: #DEF1FE;
			}

			&_orange {
				color: #FF9F43;
				background-color: #FEF1E4;
			}

			&_purple {
				color: #7367F0;
				background-color: #ECE9FC;
			}
		}

		@media screen and (min-width: 1501px) {
			width: 20% !important;
		}
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}

	.vx-card {
		height: 100%;
		//padding-right: 220px;
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}
}

.vs-popup {
	max-width: 400px !important;

	.vs-textarea {
		height: 100px;
	}

	&--title {
		h3 {
			color: $warning;
		}
	}

	p {
		padding: 1rem;
	}

	&--button {
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid #e4e4e4;
		padding: 1rem;
		padding-bottom: 0.5rem;
	}
}

</style>
